import orderBy from "lodash-es/orderBy";

import { isNotNullish, isNullish } from "./misc";

// Legacy cast - may or may not be necessary
// oxlint-disable-next-line replo/no-as-cast, typescript/no-explicit-any -- legacy any/cast, may or may not be needed
export const EMPTY_ARRAY = Object.freeze([]) as unknown as any[];

export function filterNulls<ValueType>(
  value: Array<ValueType | null | undefined> | null | undefined,
): ValueType[] {
  if (isNullish(value)) {
    return [];
  }
  return value.filter(isNotNullish);
}

export function createArrayOfLength(length: number) {
  const result = [];
  for (let i = 0; i < length; i++) {
    result.push(i);
  }
  return result;
}

// Order-preserving even when tasks finish out of order; at most `concurrency` run at once.
export async function mapWithConcurrency<Input, Output>(
  items: Input[],
  concurrency: number,
  mapItem: (item: Input) => Promise<Output>,
): Promise<Output[]> {
  const results = new Array<Output>(items.length);
  let cursor = 0;
  const worker = async () => {
    while (cursor < items.length) {
      const index = cursor++;
      results[index] = await mapItem(items[index]!);
    }
  };
  const workerCount = Math.min(concurrency, items.length);
  await Promise.all(createArrayOfLength(workerCount).map(worker));
  return results;
}

export function getRandomElementFromArray<ValueType>(
  values: ValueType[],
): ValueType {
  return values[Math.floor(Math.random() * values.length)]!;
}

/* Returns new array */
export const orderByDate = (
  // oxlint-disable-next-line typescript/no-explicit-any -- legacy any, may or may not be needed
  target: any[],
  field: string,
  order: "desc" | "asc" = "desc",
  // oxlint-disable-next-line typescript/no-explicit-any -- legacy any, may or may not be needed
): any[] => {
  return orderBy(
    target,
    [
      // oxlint-disable-next-line typescript/no-explicit-any -- legacy any, may or may not be needed
      function (x: any) {
        return new Date(x[field]);
      },
    ],
    [order],
  );
};

export function sum(array: number[]): number {
  return array.reduce((accumulator, value) => accumulator + value, 0);
}

export function average(array: number[]): number {
  return array.length === 0 ? 0 : sum(array) / array.length;
}

export function median(array: number[]): number {
  if (array.length === 0) {
    return 0;
  }
  const sorted = [...array].sort((first, second) => first - second);
  const middle = Math.floor(sorted.length / 2);
  return sorted.length % 2 === 0
    ? (sorted[middle - 1]! + sorted[middle]!) / 2
    : sorted[middle]!;
}
